<page-headline
    [linkTitle]="pageHeadline.linkTitle"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>

<div class="row-layout-track">
    <main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>
    <div class="search-n-filter-area-size layout-padding-bottom__1rem">
        <search-dialog
            (searchOutput)="searchRows($event)"
            [searchId]="'leaderboard-rankings-position'"
            [searchBoxHeight]="44"
            [resetSearch]="false"
        >
        </search-dialog>
    </div>
</div>

<div class="row-layout-track-left-align layout-padding-bottom__1rem">
    <div class="search-n-filter-area-size">
        <angular2-multiselect
            [data]="positionList"
            [(ngModel)]="selectedPosition"
            [settings]="positionListSettings"
            (onSelect)="onSelectionChange($event)"
            (onDeSelect)="onDeSelectionChange($event)"
        >
        </angular2-multiselect>
    </div>
    <div class="display-options-action-panel-area">
        <display-options
            (displayOptionsOutput)="applyDisplayOptions($event)"
            [showCompareToDate]="false"
        >
        </display-options>
        <action-panel
            [showExportCsv]="false"
            [showSaveAsPdf]="true"
            [showPrint]="false"
            [title]="pageHeadline.pageTitle"
        >
        </action-panel>
        <div id="toggle">
            <kendo-switch [(ngModel)]="changeToggle"></kendo-switch>
        </div>
    </div>
</div>
<common-kendo-table
    [tableColumnProperties]="tableColumnProperties"
    [tableDataProperties]="tableDataProperties"
    (pageChangeEvent)="gridChangeEvent($event)"
    class="kpi-sparkline-kendo"
>
</common-kendo-table>
